import React from 'react';
import Icon from '../../../components/AppIcon';
import CityAutocomplete from '../../../components/ui/CityAutocomplete';

const DepartureCitySelector = ({ selectedCity, onCityChange, error }) => {
  // selectedCity sera maintenant un objet { code, nom, ... }

  return (
    <div className="bg-card rounded-lg p-6 maritime-shadow-sm border border-border">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="MapPin" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Ville de départ</h3>
          <p className="text-sm text-muted-foreground">D'où partez-vous pour rejoindre le ferry ?</p>
        </div>
      </div>

      <CityAutocomplete
        label="Ville de départ"
        value={selectedCity}
        onChange={onCityChange}
        error={error}
        required
        placeholder="Saisissez votre commune (ex: Nantes)"
      />

      {selectedCity?.nom && (
        <div className="mt-4 p-3 bg-primary/5 border border-primary/20 rounded-lg text-sm text-primary flex items-center gap-2">
          <Icon name="MapPin" size={14} />
          <span>Ville sélectionnée : {selectedCity?.nom}</span>
        </div>
      )}
    </div>
  );
};

export default DepartureCitySelector;